import React, { useMemo } from "react";
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Collapse,
  Tag,
} from '@lockerpm/design';

import {
} from "@ant-design/icons";


import itemsComponents from "../../../../components/items";

import {
  accessType,
  convertDateTime
} from '../../../../utils/common'

const BoxData = (props) => {
  const { TextCopy } = itemsComponents;
  const { t } = useTranslation()
  const {
    loading = false,
    className = '',
    data = [],
    params = {},
  } = props;

  const boxData = useMemo(() => {
    return data.map((d, index) => ({ ...d, stt: index + 1 + (params.page - 1) * params.size }))
  }, [data])

  return (
    <Collapse
      className={className}
      bordered={true}
      expandIconPosition="end"
      size="small"
      collapsible='icon'
    >
      {
        boxData.map((record) => <Collapse.Panel
          key={record.id}
          header={<div
            className="flex align-items justify-between"
          >
            <div className="flex align-items">
              <TextCopy
                value={record.access_key_id}
              />
            </div>
          </div>}
        >
          <div className="flex items-center mb-2">
            <p className="font-semibold mr-2">{t('common.ip_address')}:</p>
            <TextCopy
              value={record.ip}
            />
          </div>
          <div className="flex items-center mb-2">
            <p className="font-semibold mr-2">{t('common.access_type')}:</p>
            <Tag color={accessType(record.type).color}>
              <TextCopy
                value={t(accessType(record.type).label)}
              />
            </Tag>
          </div>
          <div className="flex items-center mb-2">
            <p className="font-semibold mr-2">{t('access_log.access_time')}:</p>
            <TextCopy
              value={convertDateTime(record.creation_date)}
            />
          </div>
          <div className="flex items-center mb-2">
            <p className="font-semibold mr-2">{t('common.location')}:</p>
            <TextCopy
              value={record.location}
            />
          </div>
          <div className="flex items-center">
            <p className="font-semibold mr-2">{t('common.client')}:</p>
            <TextCopy
              value={record.client}
            />
          </div>
        </Collapse.Panel>)
      }
    </Collapse>
  );
}

export default BoxData;
